export const GET_COO_STATISTICS_URL = `/index.php`;
